import { SharedAngular } from '@Angular.Runner/@types/sharedAngular';
import angular from 'angular';

angular.module('fg').controller('fgEditController', [
  '$scope',
  'fgConfig',
  'APP_CONFIG',
  'flowinglyConstants',
  'workflowStore',
  function (
    $scope,
    fgConfig,
    appConfig: SharedAngular.APP_CONFIG,
    flowinglyConstants: SharedAngular.FlowinglyConstants,
    workflowStore: SharedAngular.WorkflowStore
  ) {
    $scope.templates = angular.copy(fgConfig.fields.templates);
    $scope.fieldIconsEnabled = appConfig.enableFieldIcons === true;

    const fieldTemplatesByType = new Map(
      fgConfig.fields.templates.map((template) => [template.type, template])
    );

    $scope.getFieldPaletteIcon = function (formField) {
      const fieldTemplate = fieldTemplatesByType.get(formField.type);
      return fieldTemplate?.paletteIcon || 'fa-light fa-square';
    };

    $scope.getFieldPaletteName = function (formField) {
      const fieldTemplate = fieldTemplatesByType.get(formField.type);
      return formField.typeName || fieldTemplate?.displayName || formField.type;
    };

    if (!appConfig.enableFormFieldReCaptcha) {
      // filter out the recaptcha field from the list in form designer
      $scope.templates = $scope.templates.filter(
        (field) => field.type !== flowinglyConstants.formFieldType.RECAPTCHA
      );

      // to remove the recaptcha field from the canvas designer where the user looks their form
      const recaptchaField = $scope.schema?.fields?.find(
        (f) => f.type === flowinglyConstants.formFieldType.RECAPTCHA
      );
      if (recaptchaField) {
        recaptchaField.hide = true;
      }
    }

    if (!appConfig.enableProcedures) {
      $scope.templates = $scope.templates.filter(
        (field) => field.type !== flowinglyConstants.formFieldType.PROCEDURE
      );
    }

    const modelType = workflowStore.getFlowModelType();
    const publishType = workflowStore.getPublishType();
    const isProcessMap =
      modelType === flowinglyConstants.flowModelType.PROCESS_MAP ||
      publishType === flowinglyConstants.flowModelPublishType.PROCESS_MAP ||
      publishType ===
        flowinglyConstants.flowModelPublishType.PROCESS_MAP_COMPONENT;

    if (!appConfig.enableFormFieldAddress || isProcessMap) {
      $scope.templates = $scope.templates.filter(
        (field) => field.type !== flowinglyConstants.formFieldType.ADDRESS
      );
    }

    if (!appConfig.enableFormFieldBusiness || isProcessMap) {
      $scope.templates = $scope.templates.filter(
        (field) =>
          field.type !== flowinglyConstants.formFieldType.EXTERNAL_BUSINESS
      );
    }

    $scope.$watch(function () {
      const schema = $scope.schemaCtrl.model();

      // to disable the recaptcha field from field when a recaptcha field is present in the form
      const recaptchaField = $scope.templates.find(
        (field) => field.type === flowinglyConstants.formFieldType.RECAPTCHA
      );
      if (recaptchaField) {
        recaptchaField.disabled = $scope.schema.fields.some(
          (field) => field.type === flowinglyConstants.formFieldType.RECAPTCHA
        );
      }

      // Seems that this watch is sometimes fired after the scope has been destroyed(?)

      if (schema) {
        const fields = schema.fields;

        if (fields) {
          let i = fields.length;

          while (--i >= 0 && !schema.$$_invalid) {
            schema.$$_invalid = fields[i].$$_invalid;

            fields[i].disabled =
              (fields[i].type === 'image' && fields[i].disabled) ||
              fields[i].type === 'fileupload';
          }
        }
      }
    });
  }
]);
